import { combineReducers } from "redux";
import authReducer from "../../features/user/authSlice";
import headerSlice from "../../features/common/headerSlice";
import rightDrawerSlice from "../../features/common/rightDrawerSlice";
import modalSlice from "../../features/common/modalSlice";
import { leadsSlice } from "../../features/leads/leadSlice";
import labTestsReducer from "../../features/labTest/labTestsSlice";
import teamsReducer from "../../features/team/teamsSlice";
import pharmacyDetailsReducer from "../../features/settings/pharmacySettings/pharmacyDetailsSlice";
import profileReducer from "../../features/settings/profilesettings/profileSlice";
import pharmacySlice from "../../features/pharmacy/pharmacySlice";
import pharmacyAppointmentsSlice from "../../features/pharmacy/pharmacyAppointmentsSlice";
import scheduleSettingsSlice from "../../features/settings/scheduleSettings/scheduleSettingsSlice";
import labTestBookingSlice from "../../features/labTestBooking/labTestBookingSlice";
import statsSlice from "../../features/dashboard/statsSlice";
import tutorialsReducer from "../../features/tutorials/tutorialsSlice";

const rootReducer = combineReducers({
  header : headerSlice,
  rightDrawer : rightDrawerSlice,
  modal : modalSlice,
  lead : leadsSlice,
  auth: authReducer,
  labTests: labTestsReducer,
  teams: teamsReducer,
  pharmacyDetails: pharmacyDetailsReducer,
  profile: profileReducer,
  pharmacy: pharmacySlice,
  pharmacyAppointments: pharmacyAppointmentsSlice,
  scheduleSettings: scheduleSettingsSlice,
  labTestBookings: labTestBookingSlice,
  stats: statsSlice,
  tutorials: tutorialsReducer,
});

export default rootReducer;
